"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteSuccessfullySent = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const layout_1 = require("../layout");
const styles_1 = require("../../styles");
const icons_1 = require("../icons");
const typography_1 = require("../typography");
const tooltip_1 = require("../tooltip/tooltip");
const NoteSuccessfullySent = ({ recordTooltipHover, }) => {
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const handleOnMouseEnter = () => {
        recordTooltipHover === null || recordTooltipHover === void 0 ? void 0 : recordTooltipHover();
        setShowTooltip(true);
    };
    const hanleOnMouseLeave = () => {
        setShowTooltip(false);
    };
    return ((0, jsx_runtime_1.jsx)(layout_1.Box, Object.assign({ onMouseEnter: handleOnMouseEnter, onMouseLeave: hanleOnMouseLeave }, { children: (0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, Object.assign({ showTooltip: showTooltip, message: (0, jsx_runtime_1.jsx)("span", { children: "Note will continue to update for some platforms" }) }, { children: (0, jsx_runtime_1.jsx)(Container, { children: (0, jsx_runtime_1.jsxs)(MessagaWrapper, { children: [(0, jsx_runtime_1.jsx)(icons_1.AppIcon, { name: "DoneIcon", color: styles_1.Theme.colors.green50 }), (0, jsx_runtime_1.jsx)(typography_1.AppText, Object.assign({ as: "span" }, { children: "Note successfully sent" }))] }) }) })) })));
};
exports.NoteSuccessfullySent = NoteSuccessfullySent;
const Container = (0, styles_1.styled)(layout_1.Box)(({ theme }) => ({
    width: '15rem',
    height: '2rem',
    borderRadius: '.625rem',
    background: theme.colors.grey05,
}));
const MessagaWrapper = (0, styles_1.styled)(layout_1.Row)({
    height: '100%',
    justifyContent: 'space-evenly',
    alignItems: 'center',
});
//# sourceMappingURL=note_successfully_sent.js.map